import type { NodeTypes } from 'reactflow';
import VisionNode from './VisionNode';
import ObjectiveNode from './ObjectiveNode';
import ActivityNode from './ActivityNode';
import RiskNode from './RiskNode';
import OpportunityNode from './OpportunityNode';
import ResourceNode from './ResourceNode';
import KPINode from './KPINode';
import StakeholderNode from './StakeholderNode';
import GroupNode from './GroupNode';
import { NodeType } from '@/types/node.types';

export const nodeTypes: NodeTypes = {
  [NodeType.Vision]: VisionNode,
  [NodeType.Objective]: ObjectiveNode,
  [NodeType.Activity]: ActivityNode,
  [NodeType.Risk]: RiskNode,
  [NodeType.Opportunity]: OpportunityNode,
  [NodeType.Resource]: ResourceNode,
  [NodeType.KPI]: KPINode,
  [NodeType.Stakeholder]: StakeholderNode,
  group: GroupNode,
};

export {
  VisionNode,
  ObjectiveNode,
  ActivityNode,
  RiskNode,
  OpportunityNode,
  ResourceNode,
  KPINode,
  StakeholderNode,
  GroupNode,
};
